import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { MailIcon } from 'lucide-react';
export function CareersPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-navy text-white font-sans selection:bg-violet-electric/30 pt-32 pb-20" data-id="element-555" data-mp="2jy9neql7d8w2">
      <section id="hero" className="max-w-4xl mx-auto px-6 text-center" data-id="element-556" data-mp="2f0gis1zjsmxw">
        <motion.span initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-violet-electric text-sm font-semibold tracking-widest uppercase mb-6 block" data-id="element-557" data-mp="2ay3ezj4d2z3r">

          Join the team
        </motion.span>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8" data-id="element-558" data-mp="2105qcuilb0am">

          Build the future of manufacturing
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="prose prose-invert prose-lg mx-auto mb-12" data-id="element-559" data-mp="3qfn0j785vxen">

          <p className="text-xl text-white/60 leading-relaxed" data-id="element-560" data-mp="cr73e6nfucbv">
            We're always looking for new talent to help us build the operating
            system for the physical world. If you're passionate about solving
            hard problems in manufacturing and software, we want to hear from
            you.
          </p>
          <p className="text-xl text-white/60 leading-relaxed mt-6" data-id="element-561" data-mp="vkawnqwqun5y">
            Reach out with your resume and tell us what you're building.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="inline-block" data-id="element-562" data-mp="lu839plpn773">

          <a href="mailto:careers@thruline.ai" className="flex items-center gap-3 px-8 py-4 rounded-full bg-white/5 border border-white/10 hover:bg-white/10 hover:border-violet-electric/50 transition-all group" data-id="element-563" data-mp="1eaivvxxbotgv">

            <div className="w-10 h-10 rounded-full bg-violet-electric/20 flex items-center justify-center group-hover:bg-violet-electric/30 transition-colors" data-id="element-564" data-mp="1j6wp46kf4ld7">
              <MailIcon className="w-5 h-5 text-violet-electric" data-id="element-565" data-mp="1f7xnovxwb6qi" />
            </div>
            <div className="text-left" data-id="element-566" data-mp="1a68d1hel4v2y">
              <span className="block text-xs text-white/40 uppercase tracking-wider font-semibold" data-id="element-567" data-mp="157dgzdrlxa0w">
                Email us
              </span>
              <span className="block text-lg font-medium text-white" data-id="element-568" data-mp="10g594m5xdwpu">
                careers@thruline.ai
              </span>
            </div>
          </a>
        </motion.div>
      </section>
    </div>;
}